import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core'
import * as ScreenPermissions from 'core/EventActions'

import DayAheadLMP from 'marginanalysis/importdata/DayAheadLMP'
import RealTimeLMP from 'marginanalysis/importdata/RealTimeLMP'

const OutageAnalyzerDataRoutes = ({ actionPermits, envConfig }) => {
  const daPermissionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.DALMP_READ,
          ScreenPermissions.DALMP_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const rtPermissionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.RTLMP_WRITE,
          ScreenPermissions.RTLMP_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  return (
    <>
      {daPermissionPermission && (
        <Route
          exact
          path="/marginanalysis-dayaheadlmp"
          component={DayAheadLMP}
        />
      )}
      {rtPermissionPermission && (
        <Route
          exact
          path="/marginanalysis-realtimelmp"
          component={RealTimeLMP}
        />
      )}
    </>
  )
}

export { OutageAnalyzerDataRoutes }
